import React from 'react'
import SarasWrapper from '../../container/SarasWrapper'
import SarasMenu from '../../repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../repeater/menu/SarasFormMenuRow'
import ActionButton from '../../input/buttons/button/SarasButton'

const FormMenu = (props) => {
    const { formObject, action, directForSingle, rowKey, headerKey, disableToHide, customWrapper, ...restProps } = props;

    const viewData = formObject.getFormRow(rowKey, headerKey);

    const values = viewData ? Object.values(viewData.rowValues) : [];
    const disabled = disableToHide ? !values || values.length === 0 : false;

    const renderFormMenu = () => {
        
        return (
            <ActionButton 
                disabled={disabled} 
                {...restProps} 
            />
        )
    }

    const getSelectedRow = (value) => {
        // console.log("report value", value);
        if(value){
            // let selectedItem = viewData.rowValues[value];
            // if(!selectedItem)
            let selectedItem = viewData.rowValues[Object.keys(viewData.rowValues)[value]];
            // console.log("report item", Object.keys(viewData.rowValues)[value], selectedItem);
            return selectedItem;
        }
    }

    const onMenuItemClick = (e, value) => {
        let selectedItem = getSelectedRow(value);
        let datalist = selectedItem.dataList;
        var actionParam = formObject.convertStrToKeyValue(datalist.actionParam)
        let actionId = datalist.actionId;
        let actionName = datalist.actionName;
        let importState = datalist.importState || 0;

        if(actionId === "next_step"){
            actionId = "import";
            importState = 3;
        }

        if(actionId === "import"){
            actionParam = {...actionParam, imdtId:formObject.masterKeys.dtId, imdocId:formObject.masterKeys.dId, is:importState};

            if(action.isBatchAction === 1){
                actionParam = {...actionParam, tdtId:selectedItem.val, dIds:action.dIds, is:importState || 4};
            }
        }

        let customAction = { actionId: actionId, isCompHeader: action ? action.isCompHeader : 0, actionParam: { ...actionParam }, containerKey: action.containerKey }

        if(actionName)
        {
            customAction["actionName"]=actionName;
        }

        customAction.actionMessage = "Processing Action";
        
        formObject.onFormAction(customAction, rowKey, headerKey);
    }

    if (!viewData && !disableToHide)
        return (null)

    //comment the below to ensure menu is always rendered
    // if(values.length === 1 && directForSingle === "1"){
    //     // console.log("report", values);
    //     return(
    //         <SarasWrapper customWrapper={customWrapper}>
    //             <ActionButton onClick={() => onMenuItemClick(null, "0")} {...restProps} />
    //         </SarasWrapper>
    //     )
    // }

    //render menu if more than one option
    return (
        <SarasWrapper customWrapper={customWrapper}>
            <SarasMenu menuTrigger={renderFormMenu()}
                dataList={values}
                disableToHide={disableToHide}
                menuItem={SarasFormMenuRow} onSelection={onMenuItemClick} />
        </SarasWrapper>
    )
}

export default FormMenu;
